/**
 * WEB-4035 (решение владельца 29.10: «Лиды перенести в подписки, их в
 * исходном виде не будет никогда больше в аналитике») — обёртка маршрута
 * страницы аналитики: старая ссылка `?tab=leads` уходит во вкладку «Лиды»
 * раздела «Подписки» с заменой записи истории, а не на «Воронку» (правило
 * самой страницы «неизвестное → flow» остаётся как есть). Прочие адреса —
 * дети без изменений.
 */
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

export function AnalyticsLeadsRedirect({
  children,
}: {
  children: React.ReactNode;
}) {
  const [params] = useSearchParams();
  if (params.get('tab') === 'leads') {
    return <Navigate to="/commerce?tab=leads" replace />;
  }
  return <>{children}</>;
}
